export default __webpack_public_path__ + "39fa40459993be394ab40488bf8c6a8f.png";